export const config = {
    API_URL: process.env.VUE_APP_API_URL || "http://localhost:5115",
};
